<template>
  <div class="Search__area">
    <modal-melon-t-v />
    <div class="Search__class Search__box">
      <div class="Search__btn" :class="{ active: isActive1 }" @click="openModal1()">
        クラスで選ぶ
      </div>
      <melon-t-v-schedule-modal1 v-show="isOpenModal1" :is-open="isOpenModal1" @close="isOpenModal1 = false" @searchMelonTv="searchMelonTv" />
    </div>
    <div class="Search__instructor Search__box">
      <div class="Search__btn" :class="{ active: isActive2 }" @click="openModal2()">
        インストラクターで選ぶ
      </div>
      <melon-t-v-schedule-modal2 v-show="isOpenModal2" :is-open="isOpenModal2" @close="isOpenModal2 = false" @searchMelonTv="searchMelonTv" />
    </div>
    <div class="Search__time Search__box">
      <div class="Search__btn" data-modal-open="modal-3" :class="{ active: isActive3 }" @click="openModal3()">
        時間で選ぶ
      </div>
      <melon-t-v-schedule-modal3 v-show="isOpenModal3" :is-open="isOpenModal3" @close="isOpenModal3 = false" @searchMelonTv="searchMelonTv" />
    </div>
    <div class="Search__date Search__box">
      <div class="Search__btn Search__btn_date" data-modal-open="modal-4" @click="isOpenModal4 = true">
        日付で選ぶ
      </div>
      <melon-t-v-schedule-modal-4-mobile v-if="isMobile" @searchMelonTv="searchMelonTv" />
      <melon-t-v-schedule-modal4 v-else :is-open="isOpenModal4" @close="isOpenModal4 = false" @searchMelonTv="searchMelonTv" />
    </div>
  </div>
</template>
<script>
import MelonTVScheduleModal1 from '@/views/pages/melonTV/components/MelonTVSchedule/MelonTVScheduleModal1'
import MelonTVScheduleModal2 from '@/views/pages/melonTV/components/MelonTVSchedule/MelonTVScheduleModal2'
import MelonTVScheduleModal3 from '@/views/pages/melonTV/components/MelonTVSchedule/MelonTVScheduleModal3'
import MelonTVScheduleModal4 from './MelonTVSchedule/MelonTVScheduleModal4.vue'
import MelonTVScheduleModal4Mobile from './MelonTVSchedule/MelonTVScheduleModal4Mobile.vue'
import ModalMelonTV from '@/views/components/modals/ModalMelonTV'
export default {
  name: 'MelonTVSchedule',
  components: { MelonTVScheduleModal2, MelonTVScheduleModal1, MelonTVScheduleModal3, MelonTVScheduleModal4, ModalMelonTV, MelonTVScheduleModal4Mobile },
  data() {
    return {
      isOpenModal1: false,
      isOpenModal2: false,
      isOpenModal3: false,
      isOpenModal4: false,
      isMobile: false,
      isActive1: false,
      isActive2: false,
      isActive3: false,
      width: 0,
      height: 0
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    searchMelonTv(searchObj) {
      this.$emit('setSearchObj', searchObj)
      this.$emit('setIsSearch', true)
    },
    handleResize() {
      this.width = window.innerWidth
      this.height = window.innerHeight
      if (this.width <= 767 && this.height < 900) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    modalClose() {
      this.$emit('close')
    },
    openModal1() {
      if (this.isMobile) {
        if (this.isActive1 === false) {
          this.isActive1 = true
          this.isOpenModal1 = true
        } else {
          this.isActive1 = false
          this.isOpenModal1 = false
        }
      } else {
        this.isOpenModal1 = true
      }
    },
    openModal2() {
      if (this.isMobile) {
        if (this.isActive2 === false) {
          this.isActive2 = true
          this.isOpenModal2 = true
        } else {
          this.isActive2 = false
          this.isOpenModal2 = false
        }
      } else {
        this.isOpenModal2 = true
      }
    },
    openModal3() {
      if (this.isMobile) {
        if (this.isActive3 === false) {
          this.isActive3 = true
          this.isOpenModal3 = true
        } else {
          this.isActive3 = false
          this.isOpenModal3 = false
        }
      } else {
        this.isOpenModal3 = true
      }
    }
  }
}
</script>
